class PageRow extends React.Component {

    render() {
        var self = this;

        return (
            <div className='row page-row'>
                <div className='col-6'>
                    {this.props.children}
                </div>
                <div className='col-6'>
                    <div className='page-row__label'>
                        {this.props.title}
                    </div>
                </div>
            </div>
        );
    }
}

export default PageRow;



// WEBPACK FOOTER //
// ./ui_src/app/components/form/layout/PageRow.react.jsx